export default {
  skippers(state) {
    return state.skippers;
  },

  hasSkippers(state) {
    return state.skippers && state.skippers.length > 0;
  },
  isSkipper(_, getters, _2, rootGetters) {
    const skippers = getters.skippers;
    const userId = rootGetters.userId;

    return skippers.some(skipper => skipper.id == userId);
  },
  shouldUpdate(state) {
    const lastFetch = state.lastFetch;
    if (!lastFetch) {
      return true;
    }
    const currentTimeStamp = new Date().getTime();

    //is it more than a minute ago?
    return (currentTimeStamp - lastFetch) / 1000 > 60;
  }
};
